module.exports = __webpack_public_path__ + "assets/img/3.1e3f4b39.png";